
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"30","height":"30","rx":"15","fill":"#EAEDFF"}}),_c('path',{attrs:{"d":"M15 4l9.5 5.5v11L15 26l-9.5-5.5v-11L15 4zm0 14a3 3 0 100-6 3 3 0 000 6z","fill":"#2B4BFF"}})])
          )
        }
      }
    